import { CustomScene } from '@App/app/entities/viewer/custom-scene.model';
import { Mesh, StandardMaterial, VertexData } from 'babylonjs';
import { CAMERA_MESH_NAME } from '@App/app/configs/babylon.config';

export const createPolyhedron = (
  data: {
    vertex: number[][];
    face: number[][];
  },
  size: number,
  scene: CustomScene,
): Mesh => {
  const indices: number[] = [];
  const normals: number[] = [];
  let uvs: number[] = [];
  const faceUVS = [
    [0, 0],
    [1, 0],
    [1, 1],
    [0, 1],
  ];

  // positions
  const positions = data.vertex.flatMap((v) => [v[0] * size, v[1] * size, v[2] * size]);

  // indices from faces
  for (const face of data.face) {
    for (let j = 0; j < face.length; j++) {
      uvs = uvs.concat(faceUVS[j]);
    }
    for (let i = 0; i < face.length - 2; i++) {
      indices.push(face[0], face[i + 2], face[i + 1]);
    }
  }

  VertexData.ComputeNormals(positions, indices, normals);
  VertexData._ComputeSides(Mesh.BACKSIDE, positions, indices, normals, uvs);

  const vertexData = new VertexData();
  vertexData.positions = positions;
  vertexData.indices = indices;
  vertexData.normals = normals;
  vertexData.uvs = uvs;

  const polygon = new Mesh(CAMERA_MESH_NAME, scene);
  vertexData.applyToMesh(polygon);

  const mat = new StandardMaterial('mat', scene);
  mat.alpha = 0;
  polygon.material = mat;
  polygon.edgesWidth = 1;
  return polygon;
};
